const _utils = {
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);

    observer.observe(node, config);
    return observer;
  },
  ResizeImageUrl(url, size) {
    return url
      .replace('.webp', `_${size}.webp`)
      .replace('.jpg', `_${size}.jpg`)
      .replace('.jpeg', `_${size}.jpeg`)
      .replace('.png', `_${size}.png`);
  }
};

(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductLifeStyleImages', () => ({
      color_option: null,
      color_option_values: [],
      images_sofa: [],
      images_drapery: [],
      images_linen: [],
      selected_color: '',
      selected_color_index: 0,
      tab_index: 0,
      init() {
        this.InitWatchers();

        this.color_option = JSON.parse(this.$el.dataset.color_option);
        this.color_option_values = JSON.parse(this.$el.dataset.color_option_values);
        this.selected_color = this.$el.dataset.selected_color;
        this.images_sofa = JSON.parse(this.$el.dataset.images_sofa) || [];
        this.images_drapery = JSON.parse(this.$el.dataset.images_drapery) || [];
        this.images_linen = JSON.parse(this.$el.dataset.images_linen) || [];

        // Default to the first tab that actually has images (Sofa=0 / Curtain=1 / Linen=2), so
        // products with only curtain (or only linen) renders show on load instead of a blank Sofa tab.
        if (this.images_sofa.length) this.tab_index = 0;
        else if (this.images_drapery.length) this.tab_index = 1;
        else if (this.images_linen.length) this.tab_index = 2;
      },
      InitWatchers() {
        this.$watch('selected_color', () => {
          this.selected_color_index = this.color_option_values.findIndex(color => color.name == this.selected_color);
          let $color_swatch = document.querySelector(`[data-product-options-container] input[value="${this.selected_color}"]`);
          if ($color_swatch && !$color_swatch.checked) {
            // The theme scrolls the page when the buy-box variant changes.
            // Hold the current scroll position so choosing a color here doesn't jump to the top.
            const _y = window.pageYOffset;
            const _hold = () => window.scrollTo(0, _y);
            $color_swatch.checked = true;
            $color_swatch.dispatchEvent(new Event('change'));
            _hold();
            requestAnimationFrame(_hold);
            setTimeout(_hold, 0);
            setTimeout(_hold, 80);
          }
        });

        window.addEventListener('shopify-variants:switch-variant', (e) => {
          let option_id = `option${this.color_option.position}`;
          this.selected_color = e.detail.variant[option_id];
        });

        // Lazy: load only the selected color's preview (+ immediate neighbors), not every color up front.
        const preloadNear = () => {
          const sets = [this.images_sofa, this.images_drapery, this.images_linen];
          const arr = sets[Number(this.tab_index)] || [];
          const i = parseInt(this.selected_color_index) || 0;
          [i - 1, i, i + 1].forEach(j => {
            if (arr[j]) { let img = new Image(); img.src = this.ResizeImageUrl(arr[j], 'x1200'); }
          });
        };

        _utils.ObserveIntersection(this.$el, {}, (entries) => {
          if (entries[0].isIntersecting) preloadNear();
        });

        this.$watch('tab_index', () => preloadNear());
        this.$watch('selected_color_index', () => preloadNear());

        this.$el.addEventListener('set-tab-index', (e) => {
          this.tab_index = e.detail.tab_index;
        });
      },
      ResizeImageUrl(url, size) {
        return _utils.ResizeImageUrl(url, size);
      },
      // Returns the customization image for the selected color, or falls back to that
      // color's real fabric photo when no sofa/curtain/linen render exists (prevents broken images).
      lifestyleSrc(arr) {
        let i = this.selected_color_index;
        let url = (arr && arr[i]) ? arr[i] : '';
        if (!url) {
          let cov = this.color_option_values && this.color_option_values[i];
          url = (cov && cov.swatch_image) ? cov.swatch_image : '';
        }
        return url ? _utils.ResizeImageUrl(url, 'x1200') : '';
      },
      e_ScrollToProductForm() {
        window.scrollTo({
          top: document.querySelector('[data-product-form]').offsetTop,
          behavior: 'smooth'
        });
      }
    }));

    Alpine.data('ProductBuildMe', () => ({
      selected_color_index: 0,
      images: [],
      swatch_images: [],
      init() {
        this.InitWatchers();

        this.color_option = JSON.parse(this.$el.dataset.color_option);
        this.images = JSON.parse(this.$el.dataset.images);
        this.swatch_images = JSON.parse(this.$el.dataset.swatch_images || '[]');
        this.selected_color_index = this.$el.dataset.selected_color_index;

        // Lazy: preload only the selected color's thumbnail (+ immediate neighbors), not the whole list.
        this._preloadNear();
      },
      _preloadNear() {
        const i = parseInt(this.selected_color_index) || 0;
        [i - 1, i, i + 1].forEach(j => {
          if (this.images[j]) { let img = new Image(); img.src = this.ResizeImageUrl(this.images[j], 'x80'); }
        });
      },
      // Use the dedicated build-me render for this color; fall back to the color's own
      // fabric photo when no render exists (e.g. colors beyond the ~50 render images),
      // so the thumbnail never breaks on high-color products like Velluto.
      buildMeSrc() {
        const i = parseInt(this.selected_color_index) || 0;
        const url = this.images[i] || this.swatch_images[i];
        return url ? this.ResizeImageUrl(url, 'x80') : '';
      },
      InitWatchers() {
        window.addEventListener('shopify-variants:switch-variant', (e) => {
          let option_id = `option${this.color_option.position}`;
          this.selected_color_index = this.color_option.values.indexOf(e.detail.variant[option_id]);
          this._preloadNear();
        });
      },
      e_ScrollToLifeStyleImages(tab_index) {
        let $lifeStyleImages = document.querySelector('[data-product-lifestyle-images]');
        if (!$lifeStyleImages) return;

        $lifeStyleImages.dispatchEvent(new CustomEvent('set-tab-index', {
          detail: {
            tab_index: tab_index
          }
        }));
        window.scrollTo({
          top: $lifeStyleImages.offsetTop,
          behavior: 'smooth'
        });
      },
      ResizeImageUrl(url, size) {
        return _utils.ResizeImageUrl(url, size);
      }
    }));

    Alpine.data('per_unit', () => ({
      init() {
        // Set the suffix on first load (was previously only set on variant change),
        // and derive wording by product type so every page is consistent:
        //   Fabric -> /Per Yard or /Per Sample (from the selected Yard/Sample option)
        //   Curtains -> /Per Pair Panel ; Pillows -> /Per Pillow ; Sample Book -> /Per Sample Book
        this.applySuffix(this.$el.dataset.opt2 || '');
        this.InitWatchers();
      },
      applySuffix(opt2) {
        const t = (this.$el.dataset.ptype || '').trim();
        let out = '';
        if (t === 'Curtains') { out = '/Per Pair'; }
        else if (t === 'Pillows') { out = '/Per Pillow'; }
        else if (t === 'Sample Book') { out = '/Per Sample Book'; }
        else if (t === 'Fabric' && opt2) { out = `/Per ${opt2}`; }
        this.$el.textContent = out;
      },
      InitWatchers() {
        window.addEventListener('shopify-variants:switch-variant', (e) => {
          const v = e && e.detail && e.detail.variant;
          if (!v) return;
          // Only react to THIS product's own variant change, so changing one product
          // (e.g. in quickshop) cannot rewrite the suffix on other product cards.
          // The event carries both detail.product and detail.variant; prefer the product id.
          const productId = (e.detail.product && e.detail.product.id) || v.product_id;
          if (productId && this.$el.dataset.pid && String(productId) !== String(this.$el.dataset.pid)) return;
          this.applySuffix(v.option2);
        });
      }
    }));
  });
})();

// Quantity stepper (- / +) on product forms
(() => {
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const wrap = e.target.closest('[data-quantity-wrapper]');
    const input = wrap && wrap.querySelector('[data-quantity-input]');
    if (!input) return;
    let v = parseInt(input.value, 10);
    if (isNaN(v)) v = 1;
    v += plus ? 1 : -1;
    if (v < 1) v = 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

// Variant-grouped gallery (Test-RHF-CLAUDE-V01)
// Shows in the product thumbnail strip ONLY the images that belong to the selected
// color, grouped by the variant's SKU base (e.g. ARENA-05 -> ARENA-05, ARENA-05A-WAVY,
// ARENA-05C-SOFA). Clicking a thumbnail still uses the theme's own image-swap (we only
// filter which thumbnails are visible). Reuses the theme gallery; no custom slider.
//
// Safety:
//  - Only engages when the selected color has 2+ matching images (so plain products and
//    single-image colors are left completely untouched).
//  - On Fabric the strip is hidden by CSS until we add .vgs-ready, so if this script
//    never runs the gallery behaves exactly as before.
(() => {
  // Convert the SKU into the same form the image FILENAMES use: slashes -> underscores,
  // upper-cased. Shopify filenames can't contain "/", so the files mirror the SKU with "_"
  // (e.g. SKU PIL/ALESSANDRA/22X22-01 -> file PIL_ALESSANDRA_22X22-01, and its extra views
  // PIL_ALESSANDRA_22X22-01A/01B/01C). We also drop a leading "SMP_" so a fabric's Sample
  // variant shares its color's (Yard) images. This is what makes it work for BOTH fabrics
  // (ARENA-05) and pillows (PIL/ALESSANDRA/22X22-01).
  const groupOf = (sku) =>
    (sku || '').trim().toUpperCase().replace(/\//g, '_').replace(/^SMP_/, '');

  // name belongs to group if it equals the base, or starts with the base followed by a
  // NON-digit (so "ARENA-05" matches "ARENA-05A-WAVY" but never "ARENA-051").
  const inGroup = (name, group) => {
    if (!name || !group) return false;
    if (name === group) return true;
    if (name.indexOf(group) === 0) {
      const c = name.charAt(group.length);
      return c !== '' && !(c >= '0' && c <= '9');
    }
    return false;
  };

  const apply = (root, sku) => {
    if (!root) return;
    const thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumbnail]'));
    if (!thumbs.length) return;
    const group = groupOf(sku);

    // Reset to the theme's default state first.
    thumbs.forEach((t) => { t.style.display = ''; });
    root.classList.remove('vgs-ready');

    const matched = thumbs.filter((t) =>
      inGroup((t.getAttribute('data-filename') || '').toUpperCase(), group)
    );

    // Only filter when this color genuinely has multiple grouped images.
    if (matched.length >= 2) {
      thumbs.forEach((t) => {
        if (matched.indexOf(t) === -1) t.style.display = 'none';
      });
      root.classList.add('vgs-ready');
    }
  };

  const initAll = () => {
    document.querySelectorAll('[data-vgs-gallery]').forEach((root) => {
      apply(root, root.getAttribute('data-vgs-sku'));
    });
  };

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  window.addEventListener('shopify-variants:switch-variant', (e) => {
    const v = e && e.detail && e.detail.variant;
    if (!v) return;
    const pid = (e.detail.product && e.detail.product.id) || v.product_id;
    document.querySelectorAll('[data-vgs-gallery]').forEach((root) => {
      const rpid = root.getAttribute('data-vgs-product');
      if (rpid && pid && String(rpid) !== String(pid)) return;
      apply(root, v.sku);
    });
  });
})();
